import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

declare global {
  interface Window {
    KarlaStatic?: new (config: {
      element?: HTMLOrSVGScriptElement | null;
      model: string;
      type: string;
      variant?: string;
      custom_variables?: { name: string; value: string }[] | null;
    }) => void;
  }
}

type KarlaVariable = {
  name: string;
  value: string;
};

type KarlaVariables = KarlaVariable[];

@Injectable({ providedIn: 'root' })
export class KarlaService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  loadKarla(customVariables?: KarlaVariables | null): void {
    if (!isPlatformBrowser(this.platformId)) return;

    if (!window.KarlaStatic) {
      console.warn('KarlaStatic not loaded yet.');
      return;
    }

    // Remove the old Karla iframe
    document.querySelectorAll('iframe.karlachat--window').forEach(el => el.remove());

    new window.KarlaStatic({
      element: null,
      model: "x7RaxdaYHNR2qArSdev9", 
      type: "chat", 
      variant: "window",
      custom_variables: customVariables,
    });
  }
}